import React, { Component } from "react";
import moment from "moment";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import monthPickerHoc from "@/hoc/form/monthPickerHoc";
import { orderInfoCountByStubIdList } from "@/fetch/fetchApi";

const defaultDate = moment();

@monthPickerHoc
class ChargeOrder3Day extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      gridData: [],
      exportMes: "导出",
    };

    
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
    this.query = {
      month: defaultDate.format("YYYY-MM"),
      stubId: this.props.stubId,
      page: 1,
    };
  }

    static contextTypes = {
      store: PropTypes.object.isRequired,
    }

    componentWillMount() {
      this.init();
    }

    init() {
      console.log(this.query);
      this.setState({
        tableConfig: {
          tableColumns: [{
            name: "终端编号",
            key: "stubId",
            colType: "textCol",
            align: "center",
          },
          //  {
          //     name: '固件型号',
          //     key: 'versionType',
          //     colType: 'textCol',
          //     align: 'center',
          // },
          {
            name: "充电次数",
            key: "total",
            colType: "textCol",
            align: "center",
          }, {
            name: "充电量(度)",
            key: "power",
            colType: "textCol",
            align: "center",
          }],
          tableParam: {
            stubGroupId: this.props.stubId,
          },
          tableInfo: {
            hasRow: !1, // 是否显示checkbox
          },
          tableChange: () => {
            // grid翻页页，排序， 筛选过滤时触发
            console.debug("change");
          },
          autoRefresh: 1, // 设置为true 直接加载grid数据
          dataApi: orderInfoCountByStubIdList,
          tableKey: "statusLog",
        },
      });
    }

    fetchApi = (params) => {
      let result = {
        ...params,
      };
      if (params.month) {
        result = {
          ...result,
          month: params.month.format("YYYYMM"),
        };
      }
      return result;
    };

    render() {
      return (
        <div className="sc-page-content">
          <div className="page-panel">
            <ScGridTable config={this.state.tableConfig} />
          </div>
        </div>
      );
    }
}

export default ChargeOrder3Day;



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/chargeOrder3Day.js